<template>
	<div class="external-dialog-page"></div>
</template>

<script>
import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import IframeService from '@/utils/iframe-service';

export default {
	name: 'ExternalDialogPage',
	methods: {
		messageHandler(event) {
			const { data } = event;
			if (data.action === 'openExternalDialog') {
				const { dialogDispatcherFuntion, params } = data.payload;
				AppDialogManagerService[dialogDispatcherFuntion](params).then(
					() => {
						IframeService.sendMessageToParent({ action: 'closeDialogClicked' });
					},
					() => {
						IframeService.sendMessageToParent({ action: 'closeDialogClicked' });
					}
				);
			}
		},
	},
	mounted() {
		IframeService.addListeners(this.messageHandler);
		IframeService.sendMessageToParent({ action: 'dialogIframeLoaded' });
	},
	beforeDestroy() {
		IframeService.removeListener(this.messageHandler);
	},
};
</script>

<style scoped lang="scss"></style>
